import { useEffect } from 'react';
import { useParams } from 'react-router';
import { FuelPricingResourcesQuery, RawFuelPricingsQuery } from './InputsTable';
import {
  EditFarmPricing,
  EditPricingResource,
  FUEL_PRICING_TYPE,
} from './EditPricing';
import {
  INPUT_TYPE_FUEL,
  useInputTypeContext,
} from '../../contexts/InputTypeContext';
import { getFarmPath } from '../../utils/utils';
import { INVERTED_LIQUID_VOLUME_UNITS } from '../../constants/units';

export const EditFarmFuelPricing = () => {
  const { farmId } = useParams();
  const basePath = getFarmPath(farmId, 'data/inputs');
  const { setSelectedType } = useInputTypeContext();
  useEffect(() => {
    setSelectedType(INPUT_TYPE_FUEL);
  }, [setSelectedType]);

  return (
    <EditFarmPricing
      onDeleteRefetchQuery={RawFuelPricingsQuery}
      basePath={basePath}
      pricingType={FUEL_PRICING_TYPE}
      unitSpec={INVERTED_LIQUID_VOLUME_UNITS}
    />
  );
};

export const EditFuelPricingResource = () => {
  const { teamId } = useParams();
  const basePath = teamId ? ':rootUrl/inputs' : '/superadmin/inputs';
  const { setSelectedType } = useInputTypeContext();
  useEffect(() => {
    setSelectedType(INPUT_TYPE_FUEL);
  }, [setSelectedType]);

  return (
    <EditPricingResource
      onDeleteRefetchQuery={FuelPricingResourcesQuery}
      basePath={basePath}
      pricingType={FUEL_PRICING_TYPE}
      unitSpec={INVERTED_LIQUID_VOLUME_UNITS}
    />
  );
};
